var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section !== '')?_c('div',[_c('icon-box-zzim',{attrs:{"section":_vm.section,"is-on":_vm.isOn,"title":_vm.zzimTitle,"toggle-fn":_vm.toggle,"zzim-icon":_vm.zzimIcon,"aria-label":_vm.ariaLabelTitle}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }